var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasDescription)?_c('small',{staticClass:"form-text text-muted",attrs:{"id":_vm.descriptionId}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }